import { render, staticRenderFns } from "./brandPub.vue?vue&type=template&id=50f32fff&scoped=true"
import script from "./brandPub.vue?vue&type=script&lang=js"
export * from "./brandPub.vue?vue&type=script&lang=js"
import style0 from "./brandPub.vue?vue&type=style&index=0&id=50f32fff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f32fff",
  null
  
)

export default component.exports